import ProjectInfoTile from "./ProjectInfoTile.js";
import TechnologiesusedTile from "./TechnologiesUsedTile.js";

export default function ProjectHeader({
  description,
  video,
  vidthumbnail,
  status,
  duration,
  technologiesIcons,
  names,
  showcaseVideo = true,
}) {
  return (
    <div className="sProjectContent">
      <div>
        <div className="sProjectTextContent">
          <div className="smallProjectInfoTileContainer">
            <ProjectInfoTile title="Status" description={status} />
            <ProjectInfoTile title="Duration" description={duration} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h2>What is It</h2>
            <p>{description}</p>
          </div>
          <TechnologiesusedTile
            technologiesIcons={technologiesIcons}
            names={names}
          />
        </div>
      </div>
      {showcaseVideo ? (
        <div className="sProjectVideoContainer">
          <video src={video} controls={true} poster={vidthumbnail}></video>
        </div>
      ) : (
        <div className="sProjectVideoContainer">
          <img src={vidthumbnail} alt="Video Thumbnail" />
        </div>
      )}
    </div>
  );
}
